import React from "react";
import facebook from '../../assets/fb.png'
import Z from '../../assets/z-logo.png'
import twitter from '../../assets/twitter.png'
import linkedin from '../../assets/linkedin.png'
import insta from '../../assets/insta.png'
// next line is to make the button 'toTop' work
import { animateScroll as scroll } from "react-scroll";
// import { ExposureZero } from "@material-ui/icons";
import '../../styles/components/Footer/Footer.scss'

import "aos/dist/aos.css";

const Footer = () => {

  return (
    <div id="footer">
      <div id="mountain-footer"></div>
      <div id="footer-content">
        <div id="footer-reserved" data-aos="fade-right">
          <div id="social-links">
            <a
              href="https://www.instagram.com/ziplyneinc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={insta} height="30px" width="30px" />
            </a>
            <a
              href="https://www.facebook.com/ziplyne"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} height="30px" width="30px" />
            </a>
            <a
              href="https://twitter.com/ziplyne"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={twitter} height="30px" width="30px" />
            </a>
            <a
              href="https://www.linkedin.com/company/ziplyne/"
              target="_blank"
              rel="noopener noreferrer"
            >
                <img src={linkedin} height="30px" width="30px" /> 
            </a>
          </div>
          <div id="f-other-links">
            <a href="#/">Terms of Service</a>
            <a href="#/">Privacy Policy</a>
          </div>
          <div id="rights-reserved">
            <p>©2020 Ziplyne. All rights reserved</p>
          </div>
        </div>

        <div id="footer-menu" data-aos="fade-down" data-aos-delay="500">
          <div id="f-menu-logo">
            <a href="https://ziplyne.com/" target="_blank">
              <img src={Z} alt="" />
            </a>
          </div>
          <a href="https://ziplyne.com/" target="_blank">Home</a>
          <a href="https://ziplyne.com/product" target="_blank">Product</a>
          <a href="https://ziplyne.com/team" target="_blank">About Us</a>
          <div id="to-top" onClick={() => scroll.scrollToTop()}>
            <button style={{fontWeight: "bold"}}>To the Top</button>
          </div>
        </div>

        <div id="footer-social" data-aos="fade-right"></div>
      </div>
    </div>
  );
};

export default Footer;